/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Upload_PhotoInputs */

const en_admin_resource_form_upload_photo = /** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Photo`)
};

const de_admin_resource_form_upload_photo = /** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto hochladen`)
};

const es_admin_resource_form_upload_photo = /** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir foto`)
};

const fr_admin_resource_form_upload_photo = /** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger une photo`)
};

/** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */
const it_admin_resource_form_upload_photo = en_admin_resource_form_upload_photo;

/** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */
const pt_br2_admin_resource_form_upload_photo = en_admin_resource_form_upload_photo;

/** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */
const pl_admin_resource_form_upload_photo = en_admin_resource_form_upload_photo;

/** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */
const hu_admin_resource_form_upload_photo = en_admin_resource_form_upload_photo;

/** @type {(inputs: Admin_Resource_Form_Upload_PhotoInputs) => LocalizedString} */
const ro_admin_resource_form_upload_photo = en_admin_resource_form_upload_photo;

/**
* | output |
* | --- |
* | "Upload Photo" |
*
* @param {Admin_Resource_Form_Upload_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_upload_photo = /** @type {((inputs?: Admin_Resource_Form_Upload_PhotoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Upload_PhotoInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_upload_photo(inputs)
	if (locale === "de") return de_admin_resource_form_upload_photo(inputs)
	if (locale === "es") return es_admin_resource_form_upload_photo(inputs)
	if (locale === "fr") return fr_admin_resource_form_upload_photo(inputs)
	if (locale === "it") return it_admin_resource_form_upload_photo(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_upload_photo(inputs)
	if (locale === "pl") return pl_admin_resource_form_upload_photo(inputs)
	if (locale === "hu") return hu_admin_resource_form_upload_photo(inputs)
	return ro_admin_resource_form_upload_photo(inputs)
});
export { admin_resource_form_upload_photo as "admin.resource_form.upload_photo" }